<app-auth-layout>
    <div class="cont">
        <img class="logo" src="./assets/images/logo.svg" />
        <p *ngIf="!errCode">
            Hang tight.<br>
            We're creating your secure cloud storage right now!<br>
            <sync-icon name="upload-inprogress"></sync-icon>
        </p>
        <app-error *ngIf="errCode" [errcode]="errCode" />
    </div>
</app-auth-layout>